import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useModal } from '../components/ModalProvider';
import MagicLinkForms from '../components/MagicLinkForms';


function useOpenSignInModalCallback() {
    const modal = useModal();

    return useCallback(
        ({ onClose, ...magicLinkFormProps }) => {
            return modal.open({
                showBranding: true,
                // Setting a max width here to constrain the
                //  contents including the logo and close button
                //  to align with the inner contents of MagicLinkForms.
                //  Otherwise the logo and close button look super large.
                contentMaxWidth: '712px',
                verticalAlignment: 'flex-start',
                isCloseVisible: true,
                onClose,

                screenReaderLabel: (
                    <FormattedMessage
                        id="accounts.useOpenSignInModalCallback.screenReaderLabel"
                        defaultMessage="A dialogue box to sign into your account"
                    />
                ),

                children: (
                    <MagicLinkForms
                        {...magicLinkFormProps}
                    />
                ),
            });
        },
        [ modal ],
    );
}

export default useOpenSignInModalCallback;